<h2 mat-dialog-title>Kies een invaller voor {{ data.player.name }}:</h2>
<mat-dialog-content>
  @for (substitution of data.player.substitutions; track $index) {
    <div class="row mt-3">
      <div class="col-md-3">
        <h5>{{ Event.getType(substitution.event) }}</h5>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>Invaller</mat-label>
          <mat-select [(ngModel)]="substitution.substitute">
            <mat-option [value]="-1">Geen</mat-option>
            @for (player of data.availablePlayers; track player.id) {
              <mat-option [value]="player.id">
                {{ player.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
<!--  @if (substitute) {-->
    <button mat-button [mat-dialog-close]="{substitutions: data.player.substitutions}">Opslaan</button>
<!--  }-->
  <button mat-button (click)="onAnnulerenClick()">Annuleren</button>
</mat-dialog-actions>
